import React, { useEffect, useState } from "react";
import axios from "axios";
import * as constants from "../constants";
import WideList from "./common/WideList";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import StartIcon from "../assets/icon/startIcon";
import EndIcon from "../assets/icon/endIcon";
import queryString from "query-string";
import moment from "moment";
import Subjects from "./Subject";
import { Calendar, CheckCircle, PlayCircle } from "lucide-react";
import { getSortedSubjects } from "../services/helperFunction";

const subTabs = ["current", "past", "upcoming"];

const tabs = [
    {
      id: "current",
      label: "In Progress",
      icon: PlayCircle,
      color: "blue",

    },
    {
      id: "upcoming",
      label: "Upcoming",

      icon: Calendar,
      color: "amber",
    },
    {
      id: "past",
      label: "Completed",
      icon: CheckCircle,
      color: "green",
    },
  ];

const ProgramSubjects = (props) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { subTab } = queryString.parse(location?.search);
  const [subjectType, setSubjectType] = useState(subTab);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const [cardHeaderSettings, setCardHeaderSettings] = useState({
    headingText: "Subjects",
    description: "",
  });
  const [listData, setListData] = useState(undefined);
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const config = { headers: { "Content-Type": "application/json" } };
      const studentId = 1;
      try {
        setLoading(true);
        const response = await axios.get(
          constants.BASEURL + "Student/Subjects/" + id
        );
        parseSubjects(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const parseSubjects = (listItem) => {
    const newListData = getSortedSubjects(listItem.map((item) => {
      item.controlId = item.enrolmentModuleId;
      item.headingText = item.subjectCode + " - " + item.subjectName;
      // console.log(item.startDate + "= = " + moment(item.startDate, "DD/MM/YYYY").isAfter(moment(), "day"));
      item.linkTarget = item.linkTarget =
        item.invoiceAmountDue > 0 || moment(item.startDate, constants.dateFormat).isAfter(moment(), "day")
          ? ""
          : "../../subjects/" +
            item.subjectId +
            "/summary?programId=" +
            item.enrolmentId;

      let itemsList = [];

      if (item.startDate) {
        const subItem = {
          iconComp: <StartIcon />,
          itemText: `${item.startDate}`,
        };
        itemsList.push(subItem);
      }

      if (item.endDate) {
        const subItem = {
          iconComp: <EndIcon />,
          itemText: `${item.endDate}`,
        };
        itemsList.push(subItem);
      }

      const subItem = {
        icon: "",
        itemText: item.subjectType,
      };
      itemsList.push(subItem);

      if (item.compulsory) {
        const subItem = {
          icon: "",
          itemText: "Compulsory",
        };
        itemsList.push(subItem);
      }

      if (item.result !== "") {
        const subItem = {
          icon: "",
          itemText: `Result - ${item.result}`,
        };
        itemsList.push(subItem);
      }

      if (item.resultDate !== "") {
        const subItem = {
          icon: "M1 4c0-1.1.9-2 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4zm2 2v12h14V6H3zm2-6h2v2H5V0zm8 0h2v2h-2V0zM5 9h2v2H5V9zm0 4h2v2H5v-2zm4-4h2v2H9V9zm0 4h2v2H9v-2zm4-4h2v2h-2V9zm0 4h2v2h-2v-2z",
          itemText: `Result Date ${item.resultDate}`,
        };
        itemsList.push(subItem);
      }

      if (parseInt(item.totalAssessments) > 0) {
        const subItem = {
          icon: "",
          itemText: `Total Assessments ${item.totalAssessments}`,
        };
        itemsList.push(subItem);

        if (parseInt(item.totalAssessmentsAttempted) > 0) {
          const subItem = {
            icon: "",
            itemText: `Attempted ${item.totalAssessmentsAttempted}`,
          };
          itemsList.push(subItem);
        }

        if (parseInt(item.totalAssessmentsPending) > 0) {
          const subItem = {
            icon: "",
            itemText: `Pending ${item.totalAssessmentsPending}`,
          };
          itemsList.push(subItem);
        }
      }
      
      if (item.resultNote && item.resultNote != "") {
        const subItem = {
          icon: "",
          itemText: `Notes: ${item.resultNote}`,
        };
        itemsList.push(subItem);
      }

      item.itemList = itemsList;
      return item;
    }));

    setListData(newListData);
    setFilteredData(newListData);
    filterTabData(newListData,subjectType)
  };

  
  // Filtering data acc. to current, past and future
  const filterTabData = (data, type) => {
    const today = moment();

    let returnData = data.filter((item) => {
      const startDate = moment(item.startDate, constants.dateFormat); 
      const endDate = moment(item.endDate, constants.dateFormat); 

      switch (type) {
        // if there is no date for a subject then putting it into the current tab
        case "current":
          return !item.startDate || !item.endDate || (startDate.isSameOrBefore(today, "day") && endDate.isSameOrAfter(today, "day"));
        case "past":
          return endDate.isBefore(today, "day");
        case "upcoming":
          return startDate.isAfter(today, "day");
      }
    })
  
    setFilteredData(returnData);
  };


  const getTabCount = (data, type) => {
  if (!data || data.length === 0) return 0;

  const today = moment();

  return data.filter((item) => {
    const startDate = moment(item.startDate, constants.dateFormat);
    const endDate = moment(item.endDate, constants.dateFormat);

    switch (type) {
      case "current":
        return (
          !item.startDate ||
          !item.endDate ||
          (startDate.isSameOrBefore(today, "day") &&
            endDate.isSameOrAfter(today, "day"))
        );
      case "past":
        return endDate.isBefore(today, "day");
      case "upcoming":
        return startDate.isAfter(today, "day");
      default:
        return false;
    }
  }).length;
};

  
  

  // updating the subTab in the url
  // done to highlight the last active tab after page reload
  const handleClick = (tabname) => {
    filterTabData(listData, tabname)
    setSubjectType(tabname)
    let url = queryString.parse(location?.search)
    url.subTab = tabname;
    navigate(location.pathname+ "?" +queryString.stringify(url))
  }

  // if (!listData) {
  //   return "loading....";
  // }

  return (
    <div className="bg-white rounded-md border border-gray-200 mb-4 shadow-lg">
    <div className="flex border-b border-gray-100">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = subjectType === tab.id;

        const activeText =
          tab.color === "blue"
            ? "text-blue-500"
            : tab.color === "amber"
            ? "text-amber-500"
            : "text-green-500";

        const activeBg =
          tab.color === "blue"
            ? "bg-blue-500"
            : tab.color === "amber"
            ? "bg-amber-500"
            : "bg-green-500";

        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => handleClick(tab.id)}
            className="flex-1 flex flex-col items-center py-4 px-2 sm:px-6 relative transition-all duration-200"
          >
            <div className="flex items-center gap-2 mb-1">
            <Icon className={`w-4 h-4 ${isActive ? activeText : "text-gray-400"}`} />
            <span className={`text-[1rem] font-bold ${isActive ? activeText : "text-gray-400"}`}>
              {loading ? "-" : getTabCount(listData, tab.id)}
            </span>
          </div>

            <span className={`text-sm font-medium ${isActive ? activeText : "text-gray-400"}`}>
              {tab.label}
            </span>


            {isActive && (
              <div className={`absolute bottom-0 left-1/2 -translate-x-1/2 w-20 h-1 rounded-t-full ${activeBg}`} />
            )}
          </button>
        );
      })}

    </div>

    {/* Tab Content */}
    <div className="p-4">
      <Subjects subjects={filteredData} loading={loading} />
    </div>
  </div>

  );
};

export default ProgramSubjects;
